import { TLang } from 'src/constants/langs'

interface ITextBtn {
    lang: TLang
    text: string
}

export const textBtnFirst: ITextBtn[] = [
    {
        lang: 'en',
        text: 'Bet',
    },
    {
        lang: 'de',
        text: 'Einsatz',
    },
    {
        lang: 'ro',
        text: 'Pariu',
    },
    {
        lang: 'es',
        text: 'Apuesta',
    },
    {
        lang: 'fr',
        text: 'Mise',
    },
    {
        lang: 'it',
        text: 'Puntata',
    },
    {
        lang: 'pt',
        text: 'Aposta',
    },
    {
        lang: 'el',
        text: 'Στοίχημα',
    },
    {
        lang: 'sl',
        text: 'Stava',
    },
]
